import React from 'react';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpConfItem from 'components/molecules/SpConfItem';
import SpModal from 'components/molecules/SpModal';

import './index.sp.scss';

const PresentSP = ({ 
  onClickMainButton,
  changeModifyMode,
  confList,
  isApiError,
  showLoading,
  modalIsOpen,
  acknowledgeMap,
  onClickLastButton,
  onClickCloseButton,
  lpMode,
}) => (
  <div className="Conf-SP">
    <SpBasicTemplate 
      path={window.location.pathname} 
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
      lpMode={lpMode}
    >
      {confList.map(conf => (
        <div key={conf.title} className="conf-item">
          <SpConfItem
            title={conf.title}
            modifyLinks={conf.modifyLinks}
            type={conf.type}
            items={conf.items}
            changeModifyMode={changeModifyMode}
          />
        </div>
      ))}
      <SpModal 
        modalIsOpen={modalIsOpen}
        acknowledgeMap={acknowledgeMap}
        onClickCloseButton={onClickCloseButton}
        onClickLastButton={onClickLastButton}
      />
    </SpBasicTemplate>
  </div>
);


export default PresentSP;
